import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
    @Input() heading: string;
    @Input() icon: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/modules/page-header/page-header.component.ts